import React from 'react'
import { Stack, Text } from 'src/viewLayer/components/DesignSystem'
import InterpolateLink from 'src/viewLayer/components/shared/InterpolateLink'
import { t } from 'src/viewLayer/helpers/translations'
import { useBusinessDataPath, useBusinessPrivacyPath } from 'src/viewLayer/navigation'

const DataProcessingSection = () => {
  const businessPrivacyLink = {
    name: 'businessPrivacyLink',
    path: useBusinessPrivacyPath(),
    translation: t('login.b2b.data_processing.business_privacy_link'),
  }

  const businessDataLink = {
    name: 'businessDataLink',
    path: useBusinessDataPath(),
    translation: t('login.b2b.data_processing.business_data_link'),
  }

  return (
    <Stack gap={24}>
      <Text fontSize={'small'} fontWeight={{ small: 600, xxxsmall: 400 }}>
        {t('login.b2b.data_processing.title')}
      </Text>
      <InterpolateLink
        firstLink={businessPrivacyLink}
        secondLink={businessDataLink}
        translation={t('login.b2b.data_processing.legal_copy')}
      />
    </Stack>
  )
}

export default DataProcessingSection
